import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface LoadingIconProps {
  size?: number;
  color?: string;
}

export default function LoadingIcon({ size = 24, color = '#669AB7' }: LoadingIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path 
        d="M5.35547 17.5026L7.07666 15.7804M18.0833 17.5026L16.3622 15.7804M6.12767 5.54688L7.07666 6.49584" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <Path 
        d="M11.7226 3.85938V4.57715M11.7226 20.1428V17.7084M20.7225 11.1428H18.2883M3.28125 11.1428H5.15695" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Svg>
  );
}
